export const videos = [
    {
        //"anio" : "Videos",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "Reporte septiembre 2023 - abril 2024",
                "url" : "../uiihm/videos/primera_sesion_2024.mp4"
            },{
                "trimestre" : "Reporte mayo 2024 - octubre 2024",
                "url" : "../uiihm/videos/reporte_actividades_2024.mp4"
            },{
                "trimestre" : "Reporte noviembre 2024 - diciembre 2024",
                "url" : "../uiihm/videos/16_dias.mp4"
            },{
                "trimestre" : "Reporte diciembre 2024 - abril 2025",
                "url" : "../uiihm/videos/reporte_diciembre_2024_abril_2025.mp4"
            }
        ]
    }
]

